import { WalletConnect } from './components/WalletConnect';
import { TradeInterface } from './components/TradeInterface';
import { PriceDisplay } from './components/PriceDisplay';
import { useTelegramWebApp } from './hooks/useTelegramWebApp';
import { WalletProvider } from './providers/WalletProvider';
import { useWallet } from '@solana/wallet-adapter-react';
import { WalletModal } from '@solana/wallet-adapter-react-ui';
import { isMobileDevice, isTelegramWebApp } from './utils/walletLinks';
import './App.css';

function AppContent() {
  const { publicKey } = useWallet();
  const { webApp, isReady } = useTelegramWebApp();
  
  // Determine if we should use WalletModal (PC only, not mobile/Telegram)
  const isMobile = isMobileDevice();
  const isTelegram = isTelegramWebApp();
  const shouldUseModal = !isMobile && !isTelegram;

  // Apply Telegram theme when ready
  if (isReady && webApp) {
    document.documentElement.style.setProperty(
      '--tg-theme-bg-color',
      webApp.themeParams.bg_color || '#ffffff'
    );
    document.documentElement.style.setProperty(
      '--tg-theme-text-color',
      webApp.themeParams.text_color || '#000000'
    );
    document.documentElement.style.setProperty(
      '--tg-theme-button-color',
      webApp.themeParams.button_color || '#3390ec'
    );
    document.documentElement.style.setProperty(
      '--tg-theme-button-text-color',
      webApp.themeParams.button_text_color || '#ffffff'
    );
  }

  return (
    <>
      <div className="app">
        <header className="app-header">
          <h1>Something Dumb</h1>
        </header>

        <main className="app-main">
          <PriceDisplay />
          
          <WalletConnect />
          
          {publicKey && <TradeInterface publicKey={publicKey.toString()} />}
        </main>

      </div>
      
      {/* Only render WalletModal for PC (not mobile/Telegram) */}
      {shouldUseModal && <WalletModal />}
    </>
  );
}

function App() {
  return (
    <WalletProvider>
      <AppContent />
    </WalletProvider>
  );
}

export default App;

